import shipmentApiService from "@/services/shipmentApiService";

const packing  = {
  namespaced: true,
  state: {
    items: [],
    total: 0,
    loading: false,
    shipment: null,
    pigeonhole: null,
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_TOTAL(state, data) {
      state.total = data;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_SHIPMENT(state, loading) {
      state.shipment = loading;
    },
    SET_PIGEONHOLE(state, loading) {
      state.pigeonhole = loading;
    }
  },
  actions: {
    fetchItems(context, refresh = true) {
      if (refresh || context.state.items.length === 0) {
        context.commit("SET_LOADING", true);
        const params = {
          search: [
            { column: "qtyPicked[gt]", value: 0 },
            { column: "qtyPacked", value: 0 },
            { column: "qtyShipped", value: 0 },
          ]
        }
        shipmentApiService.shipmentItems.list(params)
          .then(response => {
            context.commit("SET_ITEMS", response.items)
            context.commit("SET_TOTAL", response.totalItems);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            context.commit("SET_LOADING", false);
          });
      }
    },

    setShipment(context, shipment) {
      context.commit("SET_SHIPMENT", shipment);
    },

    setPigeonhole(context, pigeonhole) {
      context.commit("SET_PIGEONHOLE", pigeonhole);
    },

    resetShipment(context) {
      context.commit("SET_SHIPMENT", null)
      context.commit("SET_PIGEONHOLE", null)
    },

    setPigeonholeByShipment(context, shipment) {
      const params = {
        search: {
          'shipmentItem.shipment.reference@exact': shipment.reference,
          'shipmentItem.pigeonhole.locationCode@exact': shipment.locationCode,
        }
      }

      shipmentApiService.pigeonholeItems.list(params)
          .then(response => {
            context.commit("SET_PIGEONHOLE", response.items[0])
          }).catch((err) => {
            console.log(err);
          })
          .finally(() => {
          });
    }
  }
}

export default packing;